export default {
  orders: 'Aufträge',
  allOrders: 'Alle Aufträge',
  onlyInJobReports: 'Teile werden nur in Berichten einer einzelnen Charge aufgeführt.',
};
